var map = {
	"./_custom_tour_of_britain": [
		773,
		773
	],
	"./_custom_tour_of_britain.ts": [
		773,
		773
	],
	"./_custom_worldrowing": [
		2075,
		6340,
		2075
	],
	"./_custom_worldrowing.ts": [
		2075,
		6340,
		2075
	],
	"./_custom_worldrowing_flags": [
		3076,
		6340,
		3076
	],
	"./_custom_worldrowing_flags.ts": [
		3076,
		6340,
		3076
	],
	"./american_football": [
		3595,
		3595,
		8092
	],
	"./american_football.ts": [
		3595,
		3595,
		8092
	],
	"./badminton": [
		9346,
		9346
	],
	"./badminton.ts": [
		9346,
		9346
	],
	"./badminton_team": [
		8021,
		8021
	],
	"./badminton_team.ts": [
		8021,
		8021
	],
	"./baseball": [
		5015,
		5015
	],
	"./baseball.ts": [
		5015,
		5015
	],
	"./basketball": [
		7464,
		7464,
		6621
	],
	"./basketball.ts": [
		7464,
		7464,
		6621
	],
	"./beach_volleyball": [
		5395,
		5395
	],
	"./beach_volleyball.ts": [
		5395,
		5395
	],
	"./cycling": [
		5960,
		5960
	],
	"./cycling.ts": [
		5960,
		5960
	],
	"./cyclocross": [
		2371,
		2371,
		8881
	],
	"./cyclocross.ts": [
		2371,
		2371,
		8881
	],
	"./darts": [
		3610,
		3610
	],
	"./darts.ts": [
		3610,
		3610
	],
	"./fieldhockey": [
		3020,
		3020,
		3358
	],
	"./fieldhockey.ts": [
		3020,
		3020,
		3358
	],
	"./floorball": [
		191,
		191
	],
	"./floorball.ts": [
		191,
		191
	],
	"./futsal": [
		2860,
		2860
	],
	"./futsal.ts": [
		2860,
		2860
	],
	"./gaelic_sports": [
		2989,
		2989,
		8050
	],
	"./gaelic_sports.ts": [
		2989,
		2989,
		8050
	],
	"./handball": [
		8102,
		8102
	],
	"./handball.ts": [
		8102,
		8102
	],
	"./icehockey": [
		1837,
		1837,
		5616
	],
	"./icehockey.ts": [
		1837,
		1837,
		5616
	],
	"./motoball": [
		7355,
		7355,
		7261
	],
	"./motoball.ts": [
		7355,
		7355,
		7261
	],
	"./motorsports": [
		3624,
		3624
	],
	"./motorsports.ts": [
		3624,
		3624
	],
	"./news": [
		524,
		524
	],
	"./news.ts": [
		524,
		524
	],
	"./rugby_union": [
		1933,
		1933,
		3141
	],
	"./rugby_union.ts": [
		1933,
		1933,
		3141
	],
	"./soccer": [
		6366,
		6366,
		1508
	],
	"./soccer.ts": [
		6366,
		6366,
		1508
	],
	"./softball": [
		1400,
		1400
	],
	"./softball.ts": [
		1400,
		1400
	],
	"./tabletennis": [
		4156,
		4156
	],
	"./tabletennis.ts": [
		4156,
		4156
	],
	"./tennis": [
		6246,
		6246
	],
	"./tennis.ts": [
		6246,
		6246
	],
	"./volleyball": [
		9850,
		9850
	],
	"./volleyball.ts": [
		9850,
		9850
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 515;
module.exports = webpackAsyncContext;